import React, { useState } from 'react';
import { ChevronDoubleDownIcon } from '@heroicons/react/24/outline';
const CustomBrandsCard = ({ image, title, link, onCardClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={onCardClick} // Navigate on click
            className="flex flex-col justify-between items-center w-full h-full  text-center group" // Fixed width
        >
          {/*duration-300 border-2 border-transparent hover:border-2 hover:border-solid hover:border-black  */}
            <div className=" md:h-[50px] h-[25px] w-full ">
                <div className='relative flex justify-center '>
                    {/* {isHovered && ( */}
                        <ChevronDoubleDownIcon className="w-6 h-6 md:w-7 md:h-7 text-black absolute top-[0px] opacity-0 group-hover:opacity-100 duration-300 " />
                    {/* )} */}
                </div>
            </div>
            {image && (
                <img
                    src={image}
                    alt={title || "Image"}
                    className="object-cover  rounded-lg max-h-36 md:max-h-auto"
                />
            )}
        
     
<div
                className={"w-full px-4 inline-block bg-custom-yellow group-hover:bg-black duration-300"}  
            >
                <h2 className={"text-sm font-semibold lg:text-base py-2 group-hover:text-white text-black"}>
                    {title}
                </h2>
            </div>
        </div>
    );
};

export default CustomBrandsCard;